module.exports = __webpack_public_path__ + "media/images/user-487c3b27c0b290392631de73fa0b72c0.svg";